"use client";

import { HistoricalEventData } from "@/lib/hygraph";
import HistoricalEventCard from "@components/history/historical-event-card";

interface HistoryTimelineProps {
  events: HistoricalEventData[] | null;
}

const HistoryTimeline = ({ events }: HistoryTimelineProps) => {
  if (!events) return null; // Exit early if no data

  return (
    <div className="history-timeline absolute inset-0 overflow-visible pointer-events-none">
      {/* Historical event cards - positioned relative to full-width parent */}
      {events.map((event) => (
        <HistoricalEventCard key={event.id} event={event} />
      ))}
    </div>
  );
};

export default HistoryTimeline;
